export const state = () => ({
	external_links: null,
	external_link: null,
});

export const mutations = {
	setExternalLinks(state: any, payload: any) {
		state.external_links = payload;
	},
	setExternalLink(state: any, payload: any) {
		state.external_link = payload;
	},
};

export const getters = {
	getExternalLinks: (state: any) => state.external_links,
	getExternalLink: (state: any) => state.external_link,
};

export const actions = {
	async fetchExternalLinks(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/external-links')
				.then((res) => {
					state.commit('setExternalLinks', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getExternalLink(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/external-links/' + payload)
				.then((res) => {
					state.commit('setExternalLink', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async storeExternalLink(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/external-links', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editExternalLink(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put(
					'/api/profile/external-links/' + payload.uuid,
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteExternalLink(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/external-links/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateExternalLinks(state: any, payload: any) {
		state.commit('setExternalLinks', payload);
	},

	updateExternalLink(state: any, payload: any) {
		state.commit('setExternalLink', payload);
	},
};
